import propTypes from "prop-types"
import { useEffect } from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useMutation } from "@tanstack/react-query"

import { createStore } from "services/stores"
import StoresForm from "./StoresForm"

const CreateModalStores = ({ isOpen, toggle, branchId, setShowAlertSuccess, setMsgSuccess }) => {
  const { isLoading, isError, error, isSuccess, mutateAsync } = useMutation(createStore)

  const submit = async (data) => {
    await mutateAsync({ ...data, branch_office: branchId })
  }

  useEffect(() => {
    if (isSuccess) {
      setMsgSuccess("Inventario creado satisfactoriamente")
      setShowAlertSuccess(true)
      toggle()
    }
  }, [isSuccess])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Crear Inventario
      </ModalHeader>
      <ModalBody>
        <StoresForm
          submit={submit}
          toggle={toggle}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </ModalBody>
    </Modal>
  )
}

CreateModalStores.propTypes = {
  isOpen: propTypes.any,
  toggle: propTypes.func,
  registeredPrices: propTypes.array,
  branchId: propTypes.number,
  setShowAlertSuccess: propTypes.func.isRequired,
  setMsgSuccess: propTypes.func.isRequired,
}

export default CreateModalStores
